
export const GET_DRIVER_LIST = "GET_DRIVER_LIST";
export const DRIVER_LIST_RESPONCE = "DRIVER_LIST_RESPONCE";
export const CHANGE_DRIVER_DEPOTS= "CHANGE_DRIVER_DEPOTS";
export const CHANGE_DRIVER_DEPOTS_REDUX_STATE = "CHANGE_DRIVER_DEPOTS_REDUX_STATE"
export const UPDATE_REDUX_STATE = "UPDATE_REDUX_STATE"
